import { emptyFragment, ModalBody } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import CollectionBuilder from './CollectionBuilder';
import LearningAdvisor from './LearningAdvisor';
import ModalDescription from './ModalDescription';
import { fromBool } from '@execonline-inc/maybe-adapter';
import { currentUserStore } from '../../../../CurrentUserStore';

interface Props {
  context: 'Home' | 'Learning Collections';
}

function LCModalBody({ context }: Props) {
  return (
    <ModalBody className="p-10 flex flex-col border-t border-t-solid">
      <div className="flex gap-10 flex-row justify-center">
        {fromBool(currentUserStore.exoChatbotAccessible, true)
          .map(() => <LearningAdvisor context={context} />)
          .getOrElse(emptyFragment)}
        <CollectionBuilder context={context} />
      </div>
      <ModalDescription />
    </ModalBody>
  );
}

export default observer(LCModalBody);
